import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";

const DialogSaveAttendance = ({ dialog, closeDialogAndGoToEventList }) => {
	return (
		<DialogAlertSuccessNotify
			show={dialog.value}
			toggleShow={dialog.toggle}
			title="Hemos actualizado tu asistencia"
			description={`Lo podrás visualizar en el listado de "Eventos"`}
			buttons={
				<CustomButton
					variant="quaternary"
					text="Ir al listado"
					onClick={() => {
						dialog.set(false);
						closeDialogAndGoToEventList();
					}}
				/>
			}
		/>
	);
};

export default DialogSaveAttendance;
